import * as $ from 'jquery';
import {UIElement} from "./ui";
import '/modules/common/css/ui/dropdown.css';
import '/modules/common/css/ui/dropdown.mobile.css';

/**
 * A dropdown element implemented with a select HTML element
 * @extends UIElement
 */
class Dropdown extends UIElement {

    getClassName(){
        return "Dropdown";
    }

    /**
     *
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param id {string} Dropdown id
     * @param dropDownOptions {Array<DropdownOption>} A list of options for this dropdown
     * @param initialValue {string} The initial value for this dropdown
     * @param mandatory {boolean} Is this dropdown mandatory?
     * @param emptyLabelKey {string} if not mandatory, this will be the label of the empty option
     * @param onChange {function} A callback to be called when the value changes
     * @param parentDropdown {Dropdown} If not undefined, only the options with the parentValue corresponding matching the current parentDropdown value will be available for the user to choose
     */
    constructor(translator, isMobileDevice, id, dropDownOptions, initialValue, mandatory, emptyLabelKey, onChange, parentDropdown = undefined) {
        super(id, translator, isMobileDevice, undefined, undefined);
        this.id = id;
        this.value = initialValue;
        this.dropDownOptions = dropDownOptions.slice();
        this.mandatory = mandatory;
        this.emptyLabelKey = emptyLabelKey;
        this.emptyValue = translator.translate(emptyLabelKey);
        this.parentDropdown = parentDropdown;

        if (this.parentDropdown) {
            this.parentValue = this.parentDropdown.getValue();
        }
        this.onChangeCallbacks = new Set();
        this.onChange(onChange);

        if (this.parentDropdown) {
            this.parentDropdown.onChange(parent => {
                if (parent.getValue() !== this.parentValue) {
                    this.parentValue = parent.getValue();
                    this._setOptions(true);
                }
            });
        }
    }

    disableUI() {
        if (this.uiElement)
            $('select', this.uiElement).addClass('disabled').attr('disabled', 'disabled');
    }

    enableUI() {
        if (this.uiElement)
            $('select', this.uiElement).removeClass('disabled').removeAttr('disabled');
    }

    getCode() {
        return this.id;
    }

    getUIElement() {
        if (!this.uiElement) {
            this.uiElement = $(
                '<div id="' + this.id + '" class="dropdown-input">' +
                '   <select id="' + this.id + '_select"></select><span></span>' +
                '</div>'
            );
            this._setOptions();

            let self = this;
            $('select', this.uiElement).change(function () {
                self._setValue($(this).val(), true);
                self.logStat("CHANGE {" + $(this).val() + "}")
            });
            $('span', this.uiElement).click(function () {
                $('select', self.uiElement).show();
            });
        }
        return this.uiElement;
    }

    _setOptions(triggerOnChange = false) {
        const options = [];
        for (let o in this.dropDownOptions) {
            if (!this.parentDropdown || !this.dropDownOptions[o]._getParentValue()
                || this.dropDownOptions[o]._getParentValue() === this.parentValue)
                options.push(this.dropDownOptions[o]);
        }
        if (options.length === 0)
            this.disableUI();
        else this.enableUI();

        const selectedOption = options.filter(o => o.getValue() === this.value)[0];
        if (!this.mandatory) {
            const emptyOption = new DropdownOption(this.translator, this.isMobileDevice, this.emptyLabelKey, undefined);
            options.unshift(emptyOption);
            if (!selectedOption) {
                emptyOption._select();
                if (triggerOnChange) {
                    this._setValue(undefined, triggerOnChange);
                }
            }
        }

        const select = $('select', this.uiElement).empty();
        options.map(o => o.getUIElement()).forEach(oElem => select.append(oElem));

        if (selectedOption) {
            this._setValue(this.value, triggerOnChange);
        } else if (this.mandatory && options.length > 0) {
            this._setValue(options[0].getValue(), triggerOnChange);
        }
    }

    /**
     * Get this dropdown options array
     * @return {Array<DropdownOption>}
     */
    getOptions() {
        return this.dropDownOptions;
    }

    onChange(callback) {
        if (callback) {
            this.onChangeCallbacks.add(callback);
        }
        return this;
    }

    /**
     * Get this dropdown current value
     * @return {string}
     */
    getValue() {
        return this.value;
    }

    /**
     * Set the value for this drop down
     * @param value {string}
     */
    setValue(value) {
        this._setValue(value, true);
    }

    _setValue(value, triggerOnChange = false) {
        const select = $('select', this.uiElement);

        if (value === undefined || value === this.emptyValue) {
            if (this.mandatory) {
                const firstOption = this.dropDownOptions.filter(o =>
                    (o._getParentValue() === undefined && this.parentValue === undefined)
                    || o._getParentValue() === this.parentValue)[0];
                if (firstOption) {
                    this.value = firstOption.getValue();
                    select.val(firstOption.getValue());
                }
            } else {
                select[0].selectedIndex = 0;
                this.value = undefined;
            }
        } else {
            const option = this.dropDownOptions.filter(o =>
                (!this.parentValue || o._getParentValue() === this.parentValue)
                && o.getValue() === value)[0];
            if (option) {
                this.value = option.getValue();
                option._select();
            }
        }
        if (triggerOnChange) {
            this.onChangeCallbacks.forEach(c => c(this));
        }
    }
}

/**
 * A dropdown option
 * @extends UIElement
 */
class DropdownOption extends UIElement {

    getClassName(){
        return "DropdownOption";
    }

    /**
     *
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param labelKey {string} A localization key for this option's label
     * @param value {string} The value
     * @param parentValue The parent value. If undefined, the option will show independently of the parent
     */
    constructor(translator, isMobileDevice, labelKey, value, parentValue = undefined) {
        super(labelKey, translator, isMobileDevice, undefined, undefined);
        this.translator = translator;
        this.labelKey = labelKey;
        this.value = value;
        this.parentValue = parentValue;
    }

    /**
     * update this option label
     * @param labelKey {string}
     */
    setLabelKey(labelKey) {
        this.labelKey = labelKey;
        this.getUIElement().html(this.translator.translate(this.labelKey));
    }

    getUIElement() {
        if (!this.uiElement) {
            this.uiElement = $('<option>' + this.translator.translate(this.labelKey) + '</option>');
            if (this.value) {
                this.uiElement.attr('value', this.value);
            }
        }
        return this.uiElement;
    }

    _select() {
        $('option', $(this.getUIElement().parents('select')[0])).removeAttr('selected');
        this.getUIElement().attr('selected', '');
        $(this.getUIElement().parents('select')[0]).val(this.value);
    }

    _isSelected() {
        return !!this.getUIElement().attr('selected');
    }

    /**
     * This option's value
     * @return {string}
     */
    getValue() {
        return this.value;
    }

    _getParentValue() {
        return this.parentValue;
    }

    disable() {
        this.getUIElement().attr('disabled', 'disabled');
    }

    enable() {
        this.getUIElement().removeAttr('disabled');
    }

}

export {Dropdown, DropdownOption}